// ** Redux
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// ** Helpers
import { createApiCall } from "helpers/createApiCall";

// ############################################################

// Async thunks
export const getPrivacyJson = createAsyncThunk(
	"pages/privacy/getPrivacyJson",
	createApiCall(async ({ language }, client) => {
		client.modifyLanguageHeader(language);
		const response = await client.get("/statics/support", {
			params: {
				type: "privacy",
			},
		});
		return { data: response.data, counters: response.counters, language };
	})
);

// ############################################################

// Initial state
const initialState = {
	loading: false,
	loaded: false,
	error: false,
	lang: "",
	title: "",
	subtitle: "",
	data: [],
	date: [],
};

// ############################################################

// Slice
const servicePagePrivacySlice = createSlice({
	name: "service-pages/privacy",
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			// getPrivacyJson
			.addCase(getPrivacyJson.pending, (state) => {
				state.loading = true;
			})
			.addCase(getPrivacyJson.fulfilled, (state, action) => {
				state.loading = false;
				state.loaded = true;
				state.error = false;
				state.lang = action.payload.language;
				state.title = action.payload.data[0]?.value;
				state.subtitle = action.payload.data
					?.slice(1, 5)
					.reduce((newText, item) => {
						if (typeof newText === "object") {
							return newText.value + ` ${item.value}`;
						}
						return (newText || "") + ` ${item.value}`;
					});
				state.data = action.payload.data[4]?.child;
				state.date = [
					action.payload.data[action.payload.data?.length - 1],
				];
			})
			.addCase(getPrivacyJson.rejected, (state) => {
				state.loading = false;
				state.loaded = true;
				state.error = true;
			});
	},
});

// ############################################################

export default servicePagePrivacySlice.reducer;

// ############################################################
